"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createAction(type, payload, meta) {
    return payload === undefined
        ? meta === undefined
            ? { type: type, error: false }
            : { type: type, meta: meta, error: false }
        : meta === undefined
            ? { type: type, payload: payload, error: payload instanceof Error }
            : { type: type, payload: payload, meta: meta, error: payload instanceof Error };
}
exports.createAction = createAction;
function handleActions(handlers, initialState) {
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        var handler = handlers[action.type];
        return handler ? handler(state, action) : state;
    };
}
exports.handleActions = handleActions;
